import {useSettingsQuery} from '@settings/modules/common/providers'
import {useUrlParam} from '@settings/modules/routing'

export const useGrindingCircuits = () => {
  const plantCode = useUrlParam('plantCode')
  return useSettingsQuery('grindingCircuits', [plantCode])
}
